<template><LandingPage /></template>
<script>
import LandingPage from "@/components/Landing.vue";
export default { name: "App", components: { LandingPage } };
</script>
